var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: () => (_vm.openDropdown = false),
          expression: "() => (openDropdown = false)",
        },
      ],
      staticClass: "dropdown-component",
    },
    [
      _vm.dataloaded
        ? _c("div", { staticClass: "flex-container" }, [
            _c(
              "div",
              { staticClass: "flex-row", on: { click: _vm.toggleDropdown } },
              [
                _c("div", { staticClass: "flex-col" }, [
                  _c("div", { staticClass: "flex-row pl-1 pr-1 option" }, [
                    _c("div", { staticClass: "flex-2 txt" }, [
                      _c("strong", [
                        _vm._v("[" + _vm._s(_vm.selected.easYear) + "]"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.selected.dateTime) + " "),
                    ]),
                    _c("div", { staticClass: "flex-col flex-1" }, [
                      _vm.selected.isFinal
                        ? _c("div", { staticClass: "lebel final" }, [
                            _vm._v(" " + _vm._s(_vm.$t("final")) + " "),
                          ])
                        : _vm._e(),
                    ]),
                    _c("div", { staticClass: "flex-col flex-1" }, [
                      _vm.selected.isDataFreeze
                        ? _c("div", { staticClass: "lebel data-freeze" }, [
                            _vm._v(" " + _vm._s(_vm.$t("freezed")) + " "),
                          ])
                        : _vm._e(),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "flex-col flex-1 lebel",
                        class:
                          _vm.selected.generatedBy == "User"
                            ? "user"
                            : "system",
                      },
                      [_vm._v(" " + _vm._s(_vm.selected.generatedBy) + " ")]
                    ),
                  ]),
                ]),
                _c(
                  "span",
                  { staticClass: "icon" },
                  [
                    _c("font-awesome-icon", {
                      attrs: {
                        icon: [
                          "fas",
                          _vm.openDropdown ? "angle-up" : "angle-down",
                        ],
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.openDropdown,
              expression: "openDropdown",
            },
          ],
          staticClass: "dropdown",
        },
        _vm._l(_vm.itemList, function (item) {
          return _c(
            "div",
            {
              key: item.sNo,
              staticClass: "flex-row pl-1 pr-1 option",
              on: {
                click: function ($event) {
                  return _vm.triggerSelection(item)
                },
              },
            },
            [
              _c("div", { staticClass: "flex-2 txt" }, [
                _c("strong", [_vm._v("[" + _vm._s(item.easYear) + "]")]),
                _vm._v(" " + _vm._s(item.dateTime)),
              ]),
              item.isFinal
                ? _c("div", { staticClass: "flex-col flex-1" }, [
                    _c("div", { staticClass: "lebel final" }, [
                      _vm._v(_vm._s(_vm.$t("final"))),
                    ]),
                  ])
                : _vm._e(),
              item.isDataFreeze
                ? _c("div", { staticClass: "flex-col flex-1" }, [
                    _c("div", { staticClass: "lebel data-freeze" }, [
                      _vm._v(_vm._s(_vm.$t("freezed"))),
                    ]),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "flex-col flex-1" }, [
                _c(
                  "div",
                  {
                    staticClass: "lebel",
                    class: item.generatedBy == "User" ? "user" : "system",
                  },
                  [_vm._v(" " + _vm._s(item.generatedBy) + " ")]
                ),
              ]),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }